import request from "@/util/request";
import requestShow from "@/util/requestShow";
/* POST /com/file/fileUpload
文件上传-支持多个 */
export const fileUpload = (data) => {
        return request({
            url: "/file/fileUpload",
            method: "post",
            data,
        })
    }
    /* GET /com/file/imageEcho
    图片回显 */
export const imageEcho = (params) => {
    return request({
        url: "/com/file/imageEcho",
        method: "get",
        params,
        isLoading:1
    })
}

/* GET /com/file/imageEcho
图片回显招投标首页用 */ 
export const imageEchoIndex = (params) => {
    return request({
        url: "/com/file/imageEcho",
        method: "get",
        params,
        isShow: false,
    })
}
export const imageEchoIndex2 = (params) => {
    return requestShow({
        url: "/com/file/imageEcho",
        method: "get",
        params,
        isShow: false,
    })
}

    /* GET /com/had-login/announcement/noLogin/getAnnouncementById
    根据id获取公告信息详情 */
export const getAnnouncementById = (params) => {
        return request({
            url: "/com/had-login/announcement/noLogin/getAnnouncementById",
            method: "get",
            params,
        })
    }
    /* GET /com/file/fileDownLoad
    文件下载或预览 */
export const fileDownLoad = (params) => {
    return request({
        url: "/com/file/fileDownLoad",
        method: "get",
        params,
        responseType: 'blob'
    })
}

// POST /sys/content/getContent
// 查询新闻信息
export const getContent = (data) => {
    return request({
        url: "/sys/content/getContent",
        method: "post",
        data,
    })
}



// WEBPACK FOOTER //
// ./src/api/index.js